import { render, staticRenderFns } from "./TopicAssistantResult.vue?vue&type=template&id=1564ab40&scoped=true"
import script from "./TopicAssistantResult.vue?vue&type=script&lang=js"
export * from "./TopicAssistantResult.vue?vue&type=script&lang=js"
import style0 from "./TopicAssistantResult.vue?vue&type=style&index=0&id=1564ab40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564ab40",
  null
  
)

export default component.exports